import { useDispatch, useSelector } from "react-redux";

import { AppState } from "../store/definitions";
import { Header } from "./Header";
import { NotificationBar } from "./NotificationBar";
import { WelcomeStep } from "./prechat/WelcomeStep";
import { PrechatForm } from "./prechat/PrechatForm";
import { PromocoesStep } from "./prechat/PromocoesStep";
import { updatePreEngagementStep } from "../store/actions/genericActions";

/*
 * Orquestrador das telas pré-chat: cabeçalho + notificações + o passo atual.
 * - Step 1: boas-vindas + cards (WelcomeStep)
 * - Step 2: formulário de dados (PrechatForm)
 * - Step 3: promoções — lista + a promoção aberta (PromocoesStep). Chegado pelo card reservado
 *   `promocoes`, e é a primeira tela do widget que navega por DENTRO em vez de abrir uma aba.
 * Ambos personalizáveis por marca via `config.prechat` (runtime, best-effort); ausente = default de hoje.
 */
export const PreEngagementFormPhase = () => {
    const dispatch = useDispatch();
    const step = useSelector((state: AppState) => state.session.preEngagementStep);

    return (
        <>
            <Header />
            <NotificationBar />
            {step === 3 ? (
                <PromocoesStep onVoltar={() => dispatch(updatePreEngagementStep(1))} />
            ) : step === 1 ? (
                <WelcomeStep onAbrirPromocoes={() => dispatch(updatePreEngagementStep(3))} />
            ) : (
                <PrechatForm />
            )}
        </>
    );
};
